import { render, staticRenderFns } from "./dataTableHsbc.vue?vue&type=template&id=72d4fd16&scoped=true"
import script from "./dataTableHsbc.vue?vue&type=script&lang=js"
export * from "./dataTableHsbc.vue?vue&type=script&lang=js"
import style0 from "./dataTableHsbc.vue?vue&type=style&index=0&id=72d4fd16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d4fd16",
  null
  
)

export default component.exports